DrawToolbar = App.loadClass 'core::DrawToolbar'

# #####################################
# DrawToolbarZones
#
# pretty similar to the default DrawToolbar,
# but with a few specific tweaks for handling
# the drawing of permanent management zones
# #####################################
# todo: rename
class exports.DrawToolbarZones extends DrawToolbar

    constructor: (zones = null) ->

        @colorSets = [
            { color: '#303F99', in_use: false },
            { color: '#F2DC10', in_use: false },
            { color: '#F08A2E', in_use: false },
            { color: '#D51F26', in_use: false },
            { color: '#00ACE1', in_use: false },
            { color: '#A65392', in_use: false },
            { color: '#EB468C', in_use: false },
            { color: '#008161', in_use: false },
            { color: '#974B19', in_use: false },
            { color: '#36415A', in_use: false },
            { color: '#231F20', in_use: false },
        ]

        @currentColorSet = -1
        @selectedFeature = ko.observable()

        # Call the DrawToolbar constructor.
        # Must be AFTER colorsets is defined
        super()

        if not zones? or zones.getLayers().length is 0
            @zones = new L.FeatureGroup()
        else
            @zones = zones.cloneGeom()
            # todo: make this recheck colors
            id = 0
            @zones.eachLayer (i) =>
                id++
                if not i._cloneProperties?
                    i._cloneProperties = {}

                if not i._cloneProperties.colorSet?
                    @cycleColorSets()

                    i._cloneProperties.colorSet = $.extend {}, @drawnOptions
                else
                    set = @_colorSetByColor(i._cloneProperties.colorSet.color)
                    if set isnt -1
                        @colorSets[set].in_use = true


                if not i._cloneProperties.id?
                    i._cloneProperties.id = id

                L.GeoUtil.setNestedStyles i, i._cloneProperties.colorSet

            @_setDrawnItems(@zones.getLayers()[0])

            @zones.cleanUp()

        App.map.addLayer @zones
        @undoStack  = new L.GeomUndoStack(@zones)



    _undoPressed: () =>
        @undoStack.undo()

        @reselectZone()
            #if @zones.getLayers().length is 1
            #    @_polySelected {layer: @zones.getLayers()[0]}
            #else if found

            # Handle selection
            #@drawControl.getButton("draw-select").trigger "click"

    reselectZone: () =>
        foundLayer = null
        @zones.eachLayer (l) =>
            if l._cloneProperties.id is @selectedFeature()
                foundLayer = l

        if not foundLayer?
            foundLayer = @zones.getLayers()[0]

        if @lastClicked() is 'draw-select'
            #@_initSelectTool()
            @drawControl.getButton('draw-select').trigger 'click'
            @_polySelected { target: foundLayer }
        else
            @_setDrawnItems foundLayer



    initDrawnItems: () ->
        # if we reloaded by coming back to this step, select the proper thing
        if not @drawnItems? and @zones.getLayers().length > 0
            @_setDrawnItems @zones.getLayers()[0]
            return

        @undoStack.push()
        @drawnItems = new L.FeatureGroup()
        @drawnItems._cloneProperties = {}
        # Give the collection a unique ID (so we can do matching for the
        # selected group later on when we're doing complicated stuff like
        # using the undo stack)
        @drawnItems._cloneProperties.id = ( new Date() ).getTime()
        @selectedFeature @drawnItems._cloneProperties.id
        #@drawnItems._map = App.map

        @zones.addLayer @drawnItems
        @cycleColorSets()

        @drawnItems._cloneProperties.colorSet = $.extend {}, @drawnOptions

        @prevState = @drawnItems.cloneGeom()

        if @lastClicked?()?
            if @lastClicked() in [
                'draw-poly-add',
                'draw-poly-sub',
                'draw-rect-add',
                'draw-rect-sub',
                'draw-circle-add',
                'draw-circle-sub']
                    @drawControl.getButton(@lastClicked()).trigger('click')

        @fire 'zone:added', @drawnItems



    deleteZone: (zone) ->
        if zone._cloneProperties.colorSet?.color?
            set = @_colorSetByColor(zone._cloneProperties.colorSet.color)
            if set isnt -1
                @colorSets[set].in_use = false


        # Reset selected zone
        if zone._cloneProperties.id is @drawnItems._cloneProperties.id
            if @currentTool()?.disable?
                @currentTool().disable()
                @drawControl.deselectBtn @lastClicked()


        if @zones.hasLayer(zone)
            @undoStack.push()
            @zones.removeLayer(zone)

        App.map.removeLayer zone

        if zone._cloneProperties.id is @drawnItems._cloneProperties.id
            @_setDrawnItems @zones.getLayers()[0]

        @fire 'zone:deleted', zone


    destroy: () ->
        super()

        if @zones?
            App.map.removeLayer @zones


    _selectPressed: () =>

        for i in @getZones()
            i.on 'click', @_polySelected

        @fire 'select:no-poly'
        @_initSelectTool()


    _initSelectTool: () =>
        self = this
         # This is kiind of hacky.. if the user clicks off
        # the tool without doing anything, we have to clean up
        @currentTool {
            h: null
            disable: () ->
                if @h? and @h.disable?

                    # Crop the geometry against the outer boundary...
                    # and... crop everything against it as well...
                    # blugh
                    @h.disable()
                if $.isArray @h
                    for i in @h
                        i.disable()

                for i in self.getZones()
                    i.off 'click', self._polySelected

        }


    _setDrawnItems: (geom) ->
        if not geom?
            # If geom is null or undefined, we don't want to set @drawnItems
            # because it will break things.
            # Do we want to call @initDrawnItems() or something instead?
            return

        @drawnItems = geom
        @selectedFeature @drawnItems._cloneProperties.id
        @prevState = @drawnItems.cloneGeom()
        @_setColorSet @drawnItems._cloneProperties.colorSet.fillColor


    _polySelected: (e, ee) =>
        handlers = []
        # the feature group selected
        @_setDrawnItems e.target

        @prevState = @drawnItems.cloneGeom()

        @drawnOptions = $.extend {}, @drawnItems._cloneProperties.colorSet
        @drawnItems.bringToFront()

        @drawnItems.eachLayer (layer) =>

            handler = new L.Edit.PolyWithHoles(layer, { successColor: @drawnItems._cloneProperties.colorSet.fillColor })
            handler.enable()

            handlers.push handler

            # This is a bit weird. We flag the featuregroup as invalid
            # So that next time we push to the stack, the state will be
            # flagged correctly. The reason we set it here instead of at
            # push time is because the state pushed to the stack isn't the *current*
            # feature state, it's the state just before we have altered the system;
            handler.on 'geometry-invalid', () =>
                @fire 'edit:geometry-invalid'
                @drawnItems.isInvalid = true

            handler.on 'geometry-valid', () =>
                @drawnItems.isInvalid = false
                @fire 'edit:geometry-valid'

        @fire 'select:poly-selected'

        # Disable the previous selection
        if @currentTool?()?
            if @currentTool().h? and @currentTool().h.disable?
                @currentTool().h.disable()

            if $.isArray @currentTool().h
                for i in @currentTool().h
                    i.disable()

        #@currentTool#().disable()
        @currentTool().h = handlers



    initShapeDefaults: () ->
        opts = super()

        opts.shape.fillColor    = @colorSets[@currentColorSet]
        opts.shape.color        = opts.shape.fillColor
        opts.shape.fillOpacity  = 0.6

        return opts


    getZones: () ->
        return @zones.getLayers()


    cycleColorSets: () ->
        @currentColorSet = @_firstUnusedColor()
        if @currentColorSet isnt -1
            set =  @colorSets[@currentColorSet]
            set.in_use = true
            @_setColorSet set.color


    _setColorSet: (color) ->
        @drawnOptions.fillColor = color
        @drawnOptions.color     = @drawnOptions.fillColor

        # Copy color info over to the draw control's draw options
        # so that when we draw new shapes, they'll fit this colorscheme
        if @drawControl?
            @drawControl.options.draw.polygon.shapeOptions    = @drawnOptions
            @drawControl.options.draw.rectangle.shapeOptions  = @drawnOptions
            @drawControl.options.draw.circle.shapeOptions     = @drawnOptions
            @drawControl.options.polygon    = @drawnOptions
            @drawControl.options.rectangle  = @drawnOptions
            @drawControl.options.circle     = @drawnOptions



    _firstUnusedColor: () =>
        for i, ind in @colorSets
            if i.in_use is false
                return ind

        # Generate new color
        keep_trying = true

        while keep_trying isnt undefined
            new_color = '#' + ((Math.random() * 0xFFFFFF) << 0).toString(16)
            # Make sure this is a valid hex code
            if new_color.length is 7
                keep_trying = _.find @colorSets, (set) =>
                    return  set.color is new_color

        @colorSets.push({ color: new_color, in_use: false })

        return @colorSets.length - 1

    _colorSetByColor: (color) =>
        for i, ind in @colorSets
            if i.color is color
                return ind

        return -1


    createZoneFromRemainingArea: (field) ->

        copy = @zones.cloneGeom()

        if L.GeoUtil.getSumAcreage(copy) is 0
            diff = field.cloneGeom()
        else
            # Clean up the zones (make sure it's all unnested, or
            # else the WKT lib might choke)
            group = new L.FeatureGroup()

            L.GeoUtil.unnestAdd group, copy

            # Convert the group into a unioned geometry.
            # This is ugly and hacky, but must be done to prevent crazy
            # geometry errors when trying to difference the zones against
            # the field boundary
            geom
            for i in group.getLayers()
                if not geom?
                    geom = L.GeoUtil.readFromJSTS i
                    continue

                geom = L.GeoUtil.combine geom, i, 'union'



            try
                diff = L.GeoUtil.combine field, geom, 'difference'
            catch err
                console.log('ERROR COMBINING')
                console.log err

            if diff?
                diff = L.GeoUtil.readFromJSTS(diff)
            else
                diff = field.cloneGeom()

            # create another zone
            @initDrawnItems()

        L.GeoUtil.unnestAdd @drawnItems, diff
        L.GeoUtil.setNestedStyles @drawnItems, @drawnItems._cloneProperties.colorSet
